var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTourCrossBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40909 6.54911L12.6825 0.26317C12.7709 0.158706 12.6966 0 12.56 0H10.9569C10.8624 0 10.772 0.0421874 10.7098 0.114509L6.36043 5.29955L2.0111 0.114509C1.95083 0.0421874 1.86043 0 1.764 0H0.160875C0.0242682 0 -0.0500623 0.158706 0.0383306 0.26317L5.31177 6.54911L0.0383306 12.835C0.0185297 12.8583 0.00582677 12.8868 0.00172929 12.9171C-0.00236819 12.9474 0.00231194 12.9782 0.0152145 13.0059C0.0281171 13.0336 0.0487002 13.0571 0.0745195 13.0734C0.100339 13.0898 0.13031 13.0984 0.160875 13.0982H1.764C1.85842 13.0982 1.94882 13.056 2.0111 12.9837L6.36043 7.79866L10.7098 12.9837C10.77 13.056 10.8604 13.0982 10.9569 13.0982H12.56C12.6966 13.0982 12.7709 12.9395 12.6825 12.835L7.40909 6.54911Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourCrossBlackIcon);
export default __webpack_public_path__ + "static/media/tour-cross-black-icon.f4c91daf0e4e180179a6a16affff6e63.svg";
export { ForwardRef as ReactComponent };